import { logger } from "cayo.ui";
import { newQuery } from "@cayo/shared/components/GridContainer/gridModel/Query";
import { IActionHandlerParams } from "../types";

const log = logger.getLogger("action-handlers");

export function addQuery(_: string, parameters?: IActionHandlerParams) {
  if (!parameters || !parameters.dispatch) {
    return;
  }

  log.debug("addQuery -> parameters", parameters);
  const refreshCallback = () => {
    parameters.dispatch!({ kind: "refresh", hideLoading: true, keepSelection: true });
  };
  return parameters.dispatch({
    kind: "escalate",
    action: { kind: "createNewQuery", newQuery: newQuery(), refreshCallback },
  });
}
